export const createNumberArray = (from: number, to: number) =>
  Array.from({ length: to - from + 1 }, (v, k) => k + from);

export const createNumberOptions = (from: number, to: number) =>
  createNumberArray(from, to).map((number) => ({
    value: String(number),
    label: String(number),
  }));

export const hourList = createNumberOptions(0, 24);
export const minuteList = createNumberOptions(0, 60);
export const getSum = (arr: number[]) => arr.reduce((a, b) => a + b, 0);

function getOrdinalSuffix(n: number): string {
  if (n % 100 >= 11 && n % 100 <= 13) return 'th';
  switch (n % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}

export const dayOfMonthList = createNumberOptions(1, 31).map((option) => {
  const number = Number(option.value);
  return {
    ...option,
    label: `${number}${getOrdinalSuffix(number)}`,
  };
});
